import { Carousel } from "antd";
import { ServiceSelectItem } from "components/ServiceSelectItem";
import Loader from "components/shared/loader";
import { ShortEtudeList } from "components/ShortEtudeList";
import { useGetInformationQuery } from "store/api";
import { useAuth } from "utils/hooks/useAuth";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";


export const HomePage: React.FC = () => {
  const { isAuth } = useAuth();
  const { t } = useTranslation();
  const { network, isLoading } = useSalesNetwork();
  const { data: informationData, isLoading: isInformationLoading } = useGetInformationQuery({ networkCode: network?.code }, { skip: !network?.id });
  const hasInformation = !isInformationLoading && informationData && informationData?.length > 0;
  return (
    <group data-align="center" data-direction="column" data-gap="20">
      <group
        data-background="main"
        data-color="white"
        data-space="10"
        data-align="center"
        data-direction="column"
      >
        <group data-max-length="1440" data-direction="column" data-gap="5">
          <text data-text-size="xx-large">{t("FO_WELCOME_SOFTWARE_NAME")}</text>
          <text data-text-size="large">
            {t("FO_WELCOME_SOFTWARE_DESCRIPTION")}
          </text>
        </group>
      </group>

      <group data-gap="40" data-wrap="no" data-max-length="1440">
        <group data-gap="20" data-direction="column">
          <group>
            <text data-text-size="x-large">{t("FO_WELCOME_START_STUDY")}</text>
          </group>
          <group
            data-type="grid"
            data-grid-template="300"
            data-gap="20"
            data-name="main-thumbnail"
          >
            {isLoading && <Loader />}
            {network?.services.map((service) => (
              <ServiceSelectItem key={service.code} service={service} />
            ))}
          </group>
        </group>

        {isAuth && (
          <group data-length="500" data-direction="column" data-gap="20" data-space-vertical="20">
            {hasInformation && (
              <group data-length="200" data-gap="40" data-direction="column">
                <Carousel
                  autoplay
                  autoplaySpeed={60000}
                  arrows
                  dots
                  className="info-carousel"
                >
                  {informationData.map((slide) =>
                    slide.type === "html" ? (
                      <group key={slide.id}>
                        <group data-space="20" data-direction="column" data-gap="8">
                          <wrap>
                            <div data-break="break-all" dangerouslySetInnerHTML={{ __html: slide.title }} />
                            <div data-break="break-all" dangerouslySetInnerHTML={{ __html: slide.content }} />
                          </wrap>
                        </group>
                      </group>
                    ) : slide.type === "url" ? (
                      <div key={slide.id}>
                        <div
                          className="carousel-slide"
                          style={{
                            backgroundImage: `url(${slide.url})`,
                            borderRadius: "5px",
                          }}
                        />
                      </div>
                    ) : null
                  )}
                </Carousel>
              </group>
            )
            }
            <group>
              <text data-text-size="x-large">
                {t("FO_WELCOME_MY_LAST_STUDIES")}
              </text>
            </group>
            <ShortEtudeList etudesCount={hasInformation ? 3 : 5} />
          </group >
        )}
      </group >
    </group >
  );
};
